// extracted by mini-css-extract-plugin
export default {"container-overflow":"x3KXTL","containerOverflow":"x3KXTL"};